import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#e3908a", // Main coral/pink
      light: "#ffc1bb", // Light coral
      dark: "#b0615c", // Dark coral
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#8aa7e3", // Complementary blue
      light: "#bbd4ff", // Light blue
      dark: "#5c7ab0", // Dark blue
      contrastText: "#ffffff",
    },
    background: {
      default: "#ffffff",
      paper: "#faf6f6",
    },
    text: {
      primary: "#2c1810", // Deep warm brown
      secondary: "#5a4f4d", // Muted warm gray
    },
    error: {
      main: "#d32f2f",
      light: "#ef5350",
      dark: "#c62828",
    },
    warning: {
      main: "#ed6c02",
      light: "#ff9800",
      dark: "#e65100",
    },
    info: {
      main: "#0288d1",
      light: "#03a9f4",
      dark: "#01579b",
    },
    success: {
      main: "#2e7d32",
      light: "#4caf50",
      dark: "#1b5e20",
    },
  },
  typography: {
    fontFamily: [
      "Playfair Display",
      "Dancing Script",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: "Dancing Script, cursive",
      color: "#2c1810",
    },
    h2: {
      fontFamily: "Dancing Script, cursive",
      color: "#2c1810",
    },
    h3: {
      fontFamily: "Dancing Script, cursive",
      color: "#2c1810",
    },
    h4: {
      fontFamily: "Playfair Display, serif",
      color: "#2c1810",
    },
    h5: {
      fontFamily: "Playfair Display, serif",
      color: "#2c1810",
    },
    h6: {
      fontFamily: "Playfair Display, serif",
      color: "#2c1810",
    },
    body1: {
      color: "#5a4f4d",
    },
    body2: {
      color: "#5a4f4d",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontSize: "1rem",
          padding: "8px 24px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "0px 2px 4px rgba(0,0,0,0.05)",
        },
      },
    },
  },
});

export const styles = {
  section: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    boxSizing: "border-box",
  },
  countdown: {
    background: "linear-gradient(135deg, #e3908a 0%, #b0615c 100%)",
    color: "white",
    padding: "2rem",
    borderRadius: "8px",
    margin: "2rem 0",
    boxShadow: "0px 4px 20px rgba(227, 144, 138, 0.2)",
  },
};
